module.exports = __webpack_public_path__ + "img/logo-company.087a062f.png";